/**
 * Page parametres de securite
 * Wrapper autour du composant SecuritySettings du module auth
 */

import { useNavigate } from 'react-router-dom';
import { useAuth, SecuritySettings } from '@features/auth';

export function SecuritySettingsPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!user) return null;

  return (
    <div className="flex justify-center">
      <SecuritySettings
        userId={user.id}
        onConfigure2FA={() => navigate('/dashboard/2fa')}
        onChangePassword={() => navigate('/dashboard/password')}
      />
    </div>
  );
}
